<template>
  <v-container fluid my-5>
    <v-layout justify-center align-center >
      <v-flex xs12 sm8 style="max-width:650px">
        <Panel title="Sign In">
          <form v-on:keyup.enter="login">
          <v-container fluid pa-5>
          <v-layout row wrap>
              <v-flex xs12 mb-4 v-if="error">
                <v-alert
                  :value="error"
                  type="error"
                  outline
                >
                  {{ error }}
                </v-alert>
              </v-flex>
              
              <v-flex xs12>
                <v-text-field
                  color="secondary"
                  label="Username"
                  v-model="username"
                  :rules="[rules.required]"
                  prepend-inner-icon="person"
                  outline
                ></v-text-field>
              </v-flex>
            
              <v-flex xs12>
                <v-text-field
                  color="secondary"
                  label="Password"
                  type="password"
                  v-model="password"
                  :rules="[rules.required]"
                  prepend-inner-icon="lock"
                  outline
                ></v-text-field>
              </v-flex>

              <v-flex xs12 sm6 mt-1 text-sm-left text-xs-center>
                <router-link :to="{ path: '/reset-password' }">
                  <div style="height:36px; line-height:36px; color: #3296f3">Forgot Password?</div>
                </router-link>
              </v-flex>
              <v-flex xs12 sm6 mt-1 text-xs-center text-sm-right>
                <v-btn class="ma-0"
                  v-if="!loading"
                  color="secondary"
                  v-on:click="login"
                  depressed>Login</v-btn>
                <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="secondary"
                ></v-progress-circular>
              </v-flex>
          </v-layout>
          </v-container>
          </form>
        </Panel>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import {throttle} from 'lodash'
import Panel from '@/components/Panel'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  data () {
    return {
      error: null,
      loading: null,
      username: '',
      password: '',
      rules: {
          required: value => !!value || 'Required.'
      }
    }
  },
  components: {
    Panel
  },
  mounted: function () {
    const redirect = this.$store.getters.loginRedirect;
    if (redirect) {
      this.error = redirect.reason;

      if(redirect.username) {
        this.username = redirect.username;
      }
    }
  },
  methods: {
    login: throttle(async function () {
      this.error = null;
      this.loading = true;
      // attempt teacher and classroom logins in series

      try {
        const response = await AuthenticationService.login({
          username: this.username,
          password: this.password
        })
        
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)

        this.$store.dispatch('setOnboardStatus', response.data.onboard === true)

        if (response.data.needsReset) {
          this.$router.push({
            path: '/setPassword'
          })
        }
        else if (response.data.user.needsVerification) {
          this.$router.push({
            path: '/verify'
          })
        } else if (this.$store.getters.loginRedirect) {
          const redirect = this.$store.getters.loginRedirect;
          
          this.$store.dispatch('setLoginRedirect', null)

          this.$router.push({
            path: redirect.path
          })
        } else {
          this.$router.push({
            name: 'root'
          })
        }

        return;
      } catch(err) {
        console.log(err.response.data.error);
      }

      try {
        const response = await AuthenticationService.classroomLogin({
          username: this.username,
          password: this.password
        })
        
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)

        this.$router.push({
          name: 'root'
        })

        return;

      } catch(err) {
        console.log(err.response.data.error);
      }
      
      this.error = 'Invalid Username or Password.';
      this.loading = false;
    }, 1000)
  }
}
</script>

<style scoped>
.loginBox {
  background: white;
  border-radius: 16px;
}

.form-error {
  color: red;
}
</style>

